import { useQuery } from '@tanstack/react-query';

import { getRepairOrderExistsApi } from 'api/repairOrder';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';
import { RooftopExistsI } from 'declarations/interfaces/roofTopExists';

export const useFetchTicketRoExists = (roofTopId: string, roNumber: string) => {
  return useQuery<RooftopExistsI, ApiErrorI>(
    [RequestQueryKeysE.FetchRepairOrder, roofTopId, roNumber],
    () => getRepairOrderExistsApi(roofTopId, roNumber),
    {
      enabled: !!roofTopId && !!roNumber,
    }
  );
};
